export const CONTRIBUTORS = (rnc) => `${rnc}/info/basic` 